import { IntegrationsHubSettingDefinitions } from "../../integrations-hub/catalog";
import { IntegrationsHubSettingGroups } from "../../integrations-hub/groups";
import { defineSettingsProvider } from "../provider";
import type { SettingDefinition, SettingGroupDefinition } from "../types";

export const IntegrationsHubCatalogProvider = defineSettingsProvider({
  name: "integrations hub",
  groups: IntegrationsHubSettingGroups,
  definitions: IntegrationsHubSettingDefinitions,
});

export const IntegrationsHubCatalogGroups =
  IntegrationsHubCatalogProvider.groups satisfies readonly SettingGroupDefinition[];

export const IntegrationsHubCatalogDefinitions =
  IntegrationsHubCatalogProvider.definitions satisfies readonly SettingDefinition[];
